<template>
    <app-layout title="Aanvragen">
        <template #header>
            <page-title :title="(requestType) ? requestType.type : 'Alle aanvragen'" />
        </template>

        <template #pageContent>
            <div class="flex justify-between">
                <Add
                    :requestType="(requestType) ? requestType.id : null"
                    :requestTypes="requestTypes"
                    :estimates="estimates"
                    v-if="this.$page.props.user.permissions.includes('requests.add') && route().current().split('.',2)[1] === 'all'
                        && ((requestType && !requestType.type.includes('Webshop')) || this.$page.props.user.roles.includes('admin'))"
                />
            </div>

            <Form @submitted="postForm" class="w-full">
                <Table :id="tableId" :values="requests" :filters="filters" class="mt-4">
                    <thead>
                        <tr>
                            <Th>
                                <Input
                                    name="reference"
                                    v-model="form.reference"
                                    :error="form.errors.reference"
                                    layout="vertical"
                                    class="mb-0"
                                />
                            </Th>
                            <Th v-if="requestType === null || requestType.type.includes('Dewaele') || requestType.type.includes('Offerte') || requestType.type.includes('Bestek')">
                                <Input
                                    name="external_reference"
                                    v-model="form.external_reference"
                                    :error="form.errors.external_reference"
                                    layout="vertical"
                                    class="mb-0"
                                />
                            </Th>
                            <Th>
                                <Select
                                    name="assignment_type_id"
                                    :options="assignmentTypeOptions"
                                    :emptyOption="true"
                                    v-model="form.assignment_type_id"
                                    :error="form.errors.assignment_type_id"
                                    layout="vertical"
                                    class="mb-0"
                                />
                            </Th>
                            <Th>
                                <Select
                                    name="request_type_id"
                                    :options="requestTypeOptions"
                                    :emptyOption="true"
                                    :sortByLabel="false"
                                    v-model="form.request_type_id"
                                    :error="form.errors.request_type_id"
                                    layout="vertical"
                                    class="mb-0"
                                    v-if="requestType === null"
                                />
                            </Th>
                            <Th>
                                <Input
                                    name="customer"
                                    v-model="form.customer"
                                    :error="form.errors.customer"
                                    layout="vertical"
                                    class="mb-0"
                                />
                            </Th>
                            <Th>
                                <Input
                                    name="inspection_address"
                                    v-model="form.inspection_address"
                                    :error="form.errors.inspection_address"
                                    layout="vertical"
                                    class="mb-0"
                                />
                            </Th>
                            <Th>
                                <Select
                                    name="urgent"
                                    :options="urgentOptions"
                                    :emptyOption="true"
                                    v-model="form.urgent"
                                    :error="form.errors.urgent"
                                    layout="vertical"
                                    class="mb-0"
                                />
                            </Th>
                            <Th>
                                <Select
                                    name="status"
                                    :options="statusOptions"
                                    :emptyOption="true"
                                    v-model="form.status"
                                    :error="form.errors.status"
                                    layout="vertical"
                                    class="mb-0"
                                />
                            </Th>
                            <Th v-if="!route().current().includes('reported')">
                                <Input
                                    name="requested_at"
                                    type="date"
                                    placeholder="dd-mm-jjjj"
                                    v-model="form.requested_at"
                                    :error="form.errors.requested_at"
                                    layout="vertical"
                                    class="mb-0"
                                />
                            </Th>
                            <Th>
                                <Select
                                    name="executor"
                                    :emptyOption="true"
                                    :options="allExecutors"
                                    v-model="form.executor"
                                    :error="form.errors.executor"
                                    layout="vertical"
                                    class="mb-0"
                                    v-if="this.$page.props.user.permissions.includes('requests.view.all')"
                                />
                            </Th>
                            <Th>
                                <Input
                                    name="planned_at"
                                    type="date"
                                    placeholder="dd-mm-jjjj"
                                    v-model="form.planned_at"
                                    :error="form.errors.planned_at"
                                    layout="vertical"
                                    class="mb-0"
                                />
                            </Th>
                            <Th v-if="!route().current().includes('reported')">
                                <Input
                                    name="start_time"
                                    type="time"
                                    placeholder="uu:mm"
                                    v-model="form.start_time"
                                    :error="form.errors.start_time"
                                    layout="vertical"
                                    class="mb-0"
                                />
                            </Th>
                            <Th v-if="route().current().includes('reported')">
                                <Input
                                    name="reported_at"
                                    type="date"
                                    placeholder="dd-mm-jjjj"
                                    v-model="form.reported_at"
                                    :error="form.errors.reported_at"
                                    layout="vertical"
                                    class="mb-0"
                                />
                            </Th>
                            <Th>
                                <Button
                                    text="Zoeken"
                                    buttonType="submit"
                                    buttonClass="filter"
                                    :loading="form.processing"
                                    class="mb-0"
                                />
                            </Th>
                        </tr>
                        <tr>
                            <Th id="reference">Referentie</Th>
                            <Th id="external_reference"
                                v-if="requestType === null || requestType.type.includes('Dewaele') || requestType.type.includes('Offerte') || requestType.type.includes('Bestek')"
                            >
                                Dossiernr.
                            </Th>
                            <Th id="assignment_types.name">Opdracht</Th>
                            <Th id="request_types.type">Type</Th>
                            <Th id="customer">Klant</Th>
                            <Th id="inspection_addresses.name">Inspectie adres</Th>
                            <Th id="urgent">Urgent</Th>
                            <Th id="status">Status</Th>
                            <Th id="requested_at" v-if="!route().current().includes('reported')">
                                Aangevraagd op
                            </Th>
                            <Th id="adi">ADI</Th>
                            <Th id="planned_at">Gepland op</Th>
                            <Th id="start_time" v-if="!route().current().includes('reported')">
                                Starttijd
                            </Th>
                            <Th id="reports.reported_at" v-if="route().current().includes('reported')">
                                Gerapporteerd op
                            </Th>
                            <Th :sort="false"></Th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(request, key) in state.sortedValues[tableId]" :key="key">
                            <Td>
                                <Link :href="route('requests.detail',  {'id': request.id})">
                                    {{ request.reference }}
                                </Link>
                            </Td>
                            <Td v-if="requestType === null || requestType.type.includes('Dewaele') || requestType.type.includes('Offerte') || requestType.type.includes('Bestek')">
                                {{ request.external_reference }}
                            </Td>
                            <Td>{{ request.assignment_type_name }}</Td>
                            <Td>{{ request.type }}</Td>
                            <Td>{{ request.customer }}</Td>
                            <Td>
                                {{ request.name }}<br>
                                {{ request.address }}<br>
                                {{ request.postal_code }} {{ request.place }}
                            </Td>
                            <Td class="text-center">
                                <i class="fas fa-check text-blue-dark-500" v-if="request.urgent"></i>
                            </Td>
                            <Td>{{ statusses[request.status] }}</Td>
                            <Td v-if="!route().current().includes('reported')">
                                <template v-if="request.requested_at">
                                    {{ moment(request.requested_at).format('DD-MM-YYYY') }}
                                </template>
                            </Td>
                            <Td>
                                {{ request.adi }}
                            </Td>
                            <Td>
                                {{ (request.planned_at) ? moment(request.planned_at).format('DD-MM-YYYY') : '' }}
                            </Td>
                            <Td v-if="!route().current().includes('reported')">
                                <template v-if="request.start_time">
                                    {{ moment(request.start_time, 'HH:mm:ss').format('HH:mm') }}
                                </template>
                            </Td>
                            <Td v-if="route().current().includes('reported')">
                                <template v-if="request.reported_at">
                                    {{ moment(request.reported_at).format('DD-MM-YYYY') }}
                                </template>
                            </Td>
                            <Td>
                                <Button
                                    htmlType="a"
                                    buttonClass="show"
                                    size="small"
                                    title="Details"
                                    :href="route('requests.detail',  {'id': request.id})"
                                />
                                <Button
                                    htmlType="a"
                                    buttonClass="edit"
                                    size="small"
                                    title="Bewerken"
                                    :href="route('requests.edit', { 'request': request.id })"
                                    v-if="this.$page.props.user.permissions.includes('requests.edit')"
                                />
                            </Td>
                        </tr>
                    </tbody>
                </Table>
            </Form>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import TableSearch from '@/Components/TableSearch.vue'
import Modal from '@/Components/Modal.vue'
import Form from '@/Components/Form.vue'
import Input from '@/Components/Input.vue'
import Select from '@/Components/Select.vue'

import Add from '@/Components/Requests/Add.vue'

import store from '@/store'
import moment from "moment"
import {Link, useForm} from '@inertiajs/inertia-vue3'

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        TableSearch,
        Modal,
        Link,
        Add,
        Form,
        Input,
        Select,
    },
    props: [
        'requests',
        'requestType',
        'requestTypes',
        'assignmentTypes',
        'estimates',
        'statusses',
        'requestStatusses',
        'executors',
        'filters',
    ],
    setup (props){
        const urlQueryString = window.location.search
        const urlParams = new URLSearchParams(urlQueryString)
        let tableId = 'overview-requests-'
        tableId += (route().current().includes('reported')) ? ('reported-') : ''
        tableId += (props.requestType) ? props.requestType.type.toLowerCase().replace(' ', '-') : 'all'
        let assignmentTypeOptions = {}
        let requestTypeOptions = {}
        let statusOptions = {}
        let urgentOptions = {
            0: 'Nee',
            1: 'Ja',
        }
        let allExecutors = {}//All executors, also blocked ones

        props.assignmentTypes.forEach(function(assignmentType) {
            assignmentTypeOptions[assignmentType.id] = assignmentType.name
        })

        props.requestTypes.forEach(function(requestType) {
            requestTypeOptions[requestType.id] = requestType.type
        })

        if (route().current().includes('reported'))
        {
            statusOptions = {
                'reported': 'Gerapporteerd',
                'pro-forma': 'Pro-forma',
                'invoiced': 'Gefactureerd'
            }
        }
        else
        {
            Object.values(props.requestStatusses).forEach(function(status) {
                statusOptions[status] = props.statusses[status]
            })
        }

        props.executors.forEach(function(executor) {
            allExecutors[executor.username] = executor.name

            if (executor.status === 'pending')
            {
                allExecutors[executor.username] += ' (Nog niet in dienst)'
            }
        })

        const form = useForm({
            reference: null,
            external_reference: null,
            assignment_type_id: null,
            request_type_id: null,
            customer: null,
            inspection_address: null,
            urgent: null,
            status: null,
            requested_at: null,
            executor: null,
            planned_at: null,
            start_time: null,
            reported_at: null,
        })

        function postForm()
        {
            form.transform((data) => (
                {
                    ...data,
                    page: 1,
                }))
                .post(window.location.href,
                {
                    'only': ['requests', 'filters'],
                })
        }

        return {
            state: store.state,
            ...store,
            urlParams,
            tableId,
            form,
            postForm,
            assignmentTypeOptions,
            requestTypeOptions,
            statusOptions,
            urgentOptions,
            allExecutors,
        }
    },
    created: function () {
        this.moment = moment;
    },
}

</script>
